import React, { useState, useEffect, useRef, Fragment, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { DataGridPro, GridRowEditStopReasons, GridRowModes, GridColumnMenu, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter, GRID_CHECKBOX_SELECTION_COL_DEF } from '@mui/x-data-grid-pro';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { BsPersonSquare } from 'react-icons/bs';
import { formatPhone } from '../../common/utils';
import { ToastContainer, toast } from 'react-toastify';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import LaunchPhoneBurner from '../../components/Modals/LaunchPhoneBurner';
import { ModalCtx } from '../../contexts';
import { singleSelectQuickFilter } from '../../common/utils';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import _ from 'lodash';
import { update } from '../../common/api';
import SaveGridRow from '../../components/Modals/SaveGridRow';
import NamesInGrid from './NamesInGrid';
import NoteInGrid from './NoteInGrid';
import TaskInGrid from './TaskInGrid';
import Toolbar from './toolbar';


import "react-toastify/dist/ReactToastify.css";


function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const AllOpps = ( { orgId, aid, uid, user, grids, viewing, canExport, stack, contacts, opps, loans, notes, tasks, lists, conPicklist, oppPicklist, globalPicklist, setDatagridWidth, setDatagridOrder  } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ leads, setLeads ] = useState( [] );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ hasUnsavedRows, setHasUnsavedRows ] = useState( false );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ singleSaveId, setSingleSaveId ] = useState( '' );
    const [ isDiscarding, setIsDiscarding ] = useState( false );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    
    const containerRef = useRef();
    const titleRef = useRef();
    const unsavedChangesRef = useRef( { unsavedRows: {}, rowsBeforeChange: {} } );
    const modesRef = useRef();
    modesRef.current = rowModesModel;

    const gridRef = useGridApiRef();

    const location = useLocation();

    const query = useQuery();

    
    const handleSave = async ( objType, oid, draftValues ) => {
        const [ loid, cid ] = oid.split( '#' );
        const c = contacts[cid];
        const lo = opps[loid];
        let aid;
        let id;

        if ( objType === 'contact' ) {
            aid = c.aid;
            id = c.cid;
        } else if ( objType === 'leadopp' ) {
            aid = lo.aid;
            id = lo.loid;
        }

        console.log( 'Saving: ' + aid + ' - ' + objType + ' - ' + id, draftValues );
        const updated = await update( orgId, aid, uid, objType, id, draftValues );
        if ( updated.length ) {
            toast.success( `Your ${objType} changes have been saved`, { theme: 'dark' } );
        }
    }

    const handleRowEditStop = ( params, event ) => {
        console.log( 'in handleRowEditStop' );
        // if ( params.reason === GridRowEditStopReasons.rowFocusOut ) {
        //     event.defaultMuiPrevented = true;
        // }
        if ( !isSaving && !isDiscarding ) {
            console.log( 'not saving - need to prompt', params );
            event.defaultMuiPrevented = true;
            handleModal( 'grid-save', params.id );
        }
        
    };
    
    const handleEditClick = useCallback( ( id ) => () => {
        console.log( 'in handleEditClick' );
        setRowModesModel( { 
            ...rowModesModel, 
            [id]: { mode: GridRowModes.Edit } 
        } );
    }, [ rowModesModel ] );
    
    const handleSingleSaveClick = useCallback( ( id ) => () => {
        console.log( 'in handleSingleSaveClick' );
        setSingleSaveId( id );
        setIsSaving( true );
        setRowModesModel( { 
            ...rowModesModel, 
            [id]: { mode: GridRowModes.View } 
        } );
        
        gridRef.current.stopRowEditMode( { id: id } );
    }, [ rowModesModel, gridRef ] );
    
    const handleCancelClick = useCallback( ( id ) => () => {
        console.log( 'in handleCancelClick' );
        console.log( 'resetting orig row: ', unsavedChangesRef.current.rowsBeforeChange[id] );

        gridRef.current.updateRows( [
            unsavedChangesRef.current.rowsBeforeChange[id]
        ] );
        delete unsavedChangesRef.current.rowsBeforeChange[id];
        delete unsavedChangesRef.current.unsavedRows[id];

        setHasUnsavedRows( Object.keys( unsavedChangesRef.current.unsavedRows ).length > 0 );
        setRowModesModel( {
            ...rowModesModel,
            [id]: { mode: GridRowModes.View }, // , ignoreModifications: true
        } );
        console.log( 'done discarding' );
    }, [ rowModesModel, gridRef ] );
    
    const findDiff = ( newObj, origObj ) => {
        let obj = {};

        function processKeyValue( key, value, otherObject ) {
            if ( !_.has( otherObject, key ) || !_.isEqual( value, otherObject[key] ) ) {
                obj[key] = value;
            }
        }

        _.forEach( newObj, ( value, key ) => processKeyValue( key, value, origObj ) );

        return obj;
    }

    const processRowUpdate = async ( newRow, origRow ) => {
        console.log( 'in processRowUpdate' );
        const rowId = newRow.id;
        unsavedChangesRef.current.unsavedRows[rowId] = newRow;
        if ( !unsavedChangesRef.current.rowsBeforeChange[rowId] ) {
            unsavedChangesRef.current.rowsBeforeChange[rowId] = origRow;
        }

        if ( isSaving && rowId === singleSaveId ) {
            console.log( 'isSaving...' );
            const diff = findDiff( newRow, unsavedChangesRef.current.rowsBeforeChange[rowId] );
            
            if ( Object.keys( diff ) ) {
                let objs = {};
                Object.keys( diff ).forEach( key => {
                    const col = cols.find( f => f.field === key );
                    if ( col ) {
                        if ( !objs[col.objType] ) {
                            objs[col.objType] = {};
                        }
                        objs[col.objType][key] = diff[key];
                    }
                } );
                const records = Object.keys( objs );
                for ( let i = 0; i < records.length; i++ ) {
                    const objType = records[i];
                    const obj = objs[objType];
                    await handleSave( objType, rowId, obj );
                }
            }
            
            delete unsavedChangesRef.current.rowsBeforeChange[rowId];
            delete unsavedChangesRef.current.unsavedRows[rowId];
            
            setIsSaving( false );
            setSingleSaveId( '' );
        } else if ( isDiscarding ) {
            console.log( 'isDiscarding...' );
            handleCancelClick( rowId )();
            setIsDiscarding( false );
            setSingleSaveId( '' );
        }
        
        setHasUnsavedRows(
            Object.keys( unsavedChangesRef.current.unsavedRows ).length > 0,
        );

        return newRow;
    };
    
    const handleRowModesModelChange = ( newRowModesModel ) => {
        console.log( 'in handleRowModesModelChange' );
        setRowModesModel( newRowModesModel );
    };

    const formatName = ( cid ) => {
        const r = contacts[cid]; // cl.find( f => f.cid === cid );
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };

    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'allopps';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'allopps';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const gridHelpers = {
        valueGetter: {
            contact: ( { row } ) => {
                if ( row && row.relationships && row.relationships.length > 1 ) {
                    let names = [];
                    row.relationships.forEach( f => names.push( formatName( f.cid ) ) );
                    return names.join( ', ' );
                } else {
                    return formatName( row.cid );
                }
            },
            referral: ( { row } ) => {
                return formatName( row.referredById );
            },
            referralCompany: ( { row } ) => {
                let comp = '';
                const c = contacts[row.referredById];
                if ( c && c.employer ) {
                    comp = c.employer;
                }
                return comp;
            },
            referralTeam: ( { row } ) => {
                let team = '';
                const c = contacts[row.referredById];
                if ( c && c.team ) {
                    team = c.team;
                }
                return team;
            },
            phone: ( { row } ) => {
                let p;  
                const c = contacts[row.cid];
                if ( c && c.phoneMobile && c.phoneMobile.length ) {
                    p = c.phoneMobile;
                } else if ( c && c.phone && c.phone.length ) {
                    p = c.phone;
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            email: ( { row } ) => {
                let e;
                const c = contacts[row.cid];
                if ( c && c.email && c.email.length ) {
                    e = c.email;
                }
                return ( e ) ? e : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value.match( 'T' ) ? value : value + 'T12:00:00' );
                    // d.setDate( d.getDate() + 1 );
                }
                return ( d ) ? d : null;
            },
            groups: ( { row } ) => {
                const ships = [];
                Object.keys( lists ).forEach( gid => {
                    const l = lists[gid];
                    if ( l && l.cids && l.cids.includes( row.cid ) ) {
                        ships.push( l );
                    }
                } );
                return ships;
            },
            latestClosedTask: ( { row } ) => {
                const tmpTasks = [];
                Object.keys( tasks ).forEach( tid => {
                    const t = tasks[tid];
                    if ( t.status === 'Open' ) {
                        return;
                    }
                    const yes = t.assoc?.find( f => f.cid === row.cid );
                    if ( yes ) {
                        tmpTasks.push( t );
                    }
                } );
                tmpTasks.sort( ( a, b ) => {
                    const ad = new Date( a.completedDate ? a.completedDate : a.createdDate );
                    const bd = new Date( b.completedDate ? b.completedDate : b.createdDate );
                    return bd.getTime() - ad.getTime();
                } );
                return ( tmpTasks.length ) ? tmpTasks[0] : null;
                // return row.lastTask;
            },
            latestNote: ( { row } ) => {
                const tmpNotes = [];
                Object.keys( notes ).forEach( nid => {
                    const n = notes[nid];
                    const yes = n.assoc?.find( f => f.cid === row.cid );
                    if ( yes ) {
                        tmpNotes.push( n );
                    }
                } );
                tmpNotes.sort( ( a, b ) => {
                    const ad = new Date( a.createdDate );
                    const bd = new Date( b.createdDate );
                    return bd.getTime() - ad.getTime();
                } );
                return ( tmpNotes.length ) ? tmpNotes[0] : null;
                // return row.lastNote;
            }
        },
        renderCell: {
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            // contact: ( { row } ) => {
            //     let l;
            //     if ( row && row.cid ) {
            //         const c = contacts[row.cid];
            //         if ( c ) {
            //             l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
            //         }
            //     }
            //     return l;
            // },
            contact: ( { row } ) => <NamesInGrid row={row} />,
            referral: ( { row } ) => {
                let l;
                if ( row && row.referredById ) {
                    const c = contacts[row.referredById];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            groups: ( { value } ) => {
                // return ( value && value.length ) ? value.map( m => <Link to={`/list/${m.gid}`}>{m.label}</Link> ).join( ', ' ) : null;
                return ( value && value.length ) ? value.map( m => m.label ).join( ', ' ) : null; 
            },
            latestClosedTask: ( { value } ) => {
                return <TaskInGrid task={value} />;
            },
            latestNote: ( { value } ) => {
                return <NoteInGrid note={value} />;
            },
            fileNum: ( { row } ) => {
                return ( row.lid && row.fileNum ) ? <Link to={`/loan/${row.lid}`}>{row.fileNum}</Link> : null;
            }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                return ( value ) ? value : '';
            },
            referral: ( { value } ) => {
                return ( value ) ? value : '';
            },
            groups: ( { value } ) => {
                return ( value && value.length ) ? value.map( m => m.label ).join( ', ' ) : null; 
            },
            latestClosedTask: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            },
            latestNote: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };
    
    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = ( t, grid ) => {
        let shouldOpen = true;

        const list = [];
        const cids = [];
        const loids = [];
        selectedRows.forEach( r => {
            console.log( 'row: ', r );
            const [ loid, cid ] = r.split( '#' );
            loids.push( loid );
            const c = contacts[cid];
            if ( c ) {
                cids.push( cid );
                list.push( c );
            }
        } );
                
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={cids} objType='contact' aid={viewing[0]} /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} clist={cids} objType='contact' /> );
                break;
    
            case 'list':
                setModal( <AddToGroup close={closeModal} contacts={list} /> );
                break;
    
            case 'event':
                setModal( <AddEvent close={closeModal} contacts={list} /> );
                break;

            case 'grid-save':
                setModal( <SaveGridRow close={ closeModal } setSaving={ setIsSaving } onCancel={ setIsDiscarding } setId={ setSingleSaveId } rid={ grid } /> );
                break;

            case 'phoneburner':
                setModal( <LaunchPhoneBurner close={closeModal} type='leads' data={loids} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }
    
    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }

    useEffect( () => {
        document.title = 'Third Floor - All Leads';
    }, [] );

    useEffect( () => {
        console.log( 'rowModes: ', rowModesModel );
    }, [ rowModesModel ] );

    useEffect( () => {
        console.log( 'filterModel: ', filterModel );
    }, [ filterModel ] );

    useEffect( () => {
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }

        if ( grids && grids.allopps && !gridReady ) {
            let activeFilter = false;
            setFilterName( '' );
            
            let storedCols = JSON.parse( grids.allopps.cols );
            if ( filters.fn && grids.allopps.filters && grids.allopps.filters[filters.fn] ) {
                if ( grids.allopps.filters[filters.fn].cols ) {
                    activeFilter = true;
                    setUsingFilter( true );
                    setFilterName( filters.fn );
                    storedCols = JSON.parse( grids.allopps.filters[filters.fn].cols );
                }

                if ( grids.allopps.filters[filters.fn].criteria ) {
                    const crit = JSON.parse( grids.allopps.filters[filters.fn].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.allopps.filters[filters.fn].className ) {
                    setClassLogic( grids.allopps.filters[filters.fn].className );
                }
            } else {
                if ( filters.crit ) {
                    const crit = JSON.parse( filters.crit );
                    setFilterModel( { items: crit } );
                }
                if ( grids.allopps.className ) {
                    setClassLogic( grids.allopps.className );
                }
            }

            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }

                    if ( user && user.datagrids && user.datagrids.allopps ) {
                        if ( activeFilter ) {
                            if ( user.datagrids.allopps.filters && user.datagrids.allopps.filters[filters.fn] && user.datagrids.allopps.filters[filters.fn].colSize && user.datagrids.allopps.filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids.allopps.filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids.allopps.colSize && user.datagrids.allopps.colSize[c.field] ) {
                            c.width = user.datagrids.allopps.colSize[c.field];
                        }
                    }

                    if ( c.type === 'singleSelect' ) {
                        let list = [];
                        switch ( c.sso ) {
                            case 'global':
                                list = globalPicklist[c.field];
                                break;

                            case 'contact':
                                list = conPicklist[c.field];
                                break;

                            case 'leadopp':
                                list = oppPicklist[c.field];
                                break;

                            default:
                                console.log( 'unknown/missing column object for singleSelect: ' + c.obj );
                        }
                        c.valueOptions = ( list ) ? list.map( m => {
                            return { value: m.value, label: m.label };
                        } ) : [];

                        if ( c.valueOptions.length ) {
                            c.valueOptions = [ { value: '', label: '- Not Set -' }, ...c.valueOptions ];
                        }
                    }

                    return c;
                } );

                if ( user && user.datagrids && user.datagrids.allopps ) {
                    if ( activeFilter ) {
                        if ( user.datagrids.allopps.filters && user.datagrids.allopps.filters[filters.fn] && user.datagrids.allopps.filters[filters.fn].colOrder && user.datagrids.allopps.filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids.allopps.filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids.allopps.colOrder && user.datagrids.allopps.colOrder.length ) {
                            cols = user.datagrids.allopps.colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }

                cols.push( 
                    { 
                        field: 'actions', 
                        type: 'actions', 
                        headerName: '', 
                        width: 100, 
                        cellClassName: 'actions', 
                        getActions: ( { id } ) => {
                            const isInEditMode = modesRef.current[id]?.mode === GridRowModes.Edit;
                            if ( isInEditMode ) {
                                return [
                                    <GridActionsCellItem
                                        icon={<SaveIcon />}
                                        label="Save"
                                        sx={{
                                            color: 'primary.main',
                                        }}
                                        onClick={ handleSingleSaveClick( id ) }
                                    />,
                                    <GridActionsCellItem
                                        icon={<CancelIcon />}
                                        label="Cancel"
                                        className="textPrimary"
                                        onClick={ handleCancelClick( id ) }
                                        color="inherit"
                                    />,
                                ];
                            }
                            
                            return [
                                <GridActionsCellItem
                                    icon={<EditIcon />}
                                    label="Edit"
                                    className="textPrimary"
                                    onClick={ handleEditClick( id ) }
                                    color="inherit"
                                />,
                            ];
                        } 
                    } 
                );

                setCols( cols );
                setGridReady( true );
            }
        }
    }, [ user, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady, query, handleCancelClick, handleEditClick, handleSingleSaveClick, rowModesModel, conPicklist, globalPicklist, oppPicklist ] );
    
    useEffect(() => {
        if ( location.search !== q ) {
            setGridReady( false );
            setFilterModel( { items: [] } );
            setClassLogic( '' );
            setQ( location.search );
        }
    }, [ location.search, q ] ); 
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( 155 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( opps ) {
            let list = [];
            Object.keys( opps ).forEach( o => {
                if ( opps[o].relationships ) {
                    opps[o].relationships.sort( ( a, b ) => {
                        const ad = new Date( a.createdDate );
                        const bd = new Date( b.createdDate );
                        return ad.getTime() - bd.getTime();
                    } );

                    const lor = opps[o].relationships[0]
                    if ( lor ) {
                        const c = contacts[lor.cid];
                        if ( c && viewing.includes( c.aid ) ) {
                            let fileNum;
                            let loanSource;
                            let purpose = c.purpose;
                            let cancelledReason;

                            if ( lor.lid ) {
                                const l = loans[lor.lid];
                                if ( l && l.fileNum ) {
                                    fileNum = l.fileNum;
                                    loanSource = l.source;
                                    purpose = l.purpose;
                                    cancelledReason = l.cancelledReason;
                                }

                            }

                            list.push( {
                                ...contacts[lor.cid],
                                ...lor,
                                ...opps[o],
                                oppsName: opps[o].name,
                                id: lor.lorid,
                                fileNum: fileNum,
                                loanSource: loanSource,
                                purpose: purpose,
                                cancelledReason: cancelledReason
                            } );
                        }
                    }
                }
            } );
            list.sort( ( a, b ) => {
                if ( a.oppDate && !b.oppDate ) {
                    return -1;
                } else if ( !a.oppDate && b.oppDate ) {
                    return 1;
                } else if ( !a.oppDate && !b.oppDate ) {
                    return 0;
                }

                let ad = new Date( a.oppDate );
                let bd = new Date( b.oppDate );

                if ( ad.getTime() === bd.getTime() ) {
                    ad = new Date( a.createdDate );
                    bd = new Date( b.createdDate );
                }

                return bd.getTime() - ad.getTime();
            } );
            setLeads( list );
            setLoading( false );
        }
    }, [ opps, contacts, viewing ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <BsPersonSquare />
                                        <span className='ps-2 fw-bold fs-6'>Leads</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ModalCtx.Provider value={ { openModal, closeModal, setModal } }>
                                        {
                                            ( gridReady ) ? (
                                                <DataGridPro
                                                    apiRef={gridRef}
                                                    initialState={ { 
                                                        pinnedColumns: { 
                                                            left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ],
                                                            right: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'actions' ],
                                                        }
                                                    } }
                                                    loading={ loading }
                                                    rows={leads}
                                                    columns={cols}
                                                    density='compact'
                                                    checkboxSelection
                                                    disableSelectionOnClick
                                                    slots={ { 
                                                        toolbar: Toolbar,
                                                        columnMenu: customColumnMenu 
                                                    } }
                                                    slotProps={ { toolbar: {
                                                        selectedRows: selectedRows, 
                                                        handleModal: handleModal, 
                                                        hasTxting: hasTxting, 
                                                        hasPhoneBurner: hasPhoneBurner, 
                                                        canExport: canExport,
                                                        viewing: viewing
                                                    } } }
                                                    onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                    filterModel={ filterModel }
                                                    onFilterModelChange={ ( newFilterModel ) => setFilterModel( newFilterModel ) }
                                                    getRowClassName={ getRowClassName }
                                                    getRowHeight={ () => 'auto' }
                                                    editMode='row'
                                                    rowModesModel={ rowModesModel }
                                                    onRowModesModelChange={ handleRowModesModelChange }
                                                    onRowEditStop={ handleRowEditStop }
                                                    processRowUpdate={ processRowUpdate }
                                                    onColumnWidthChange={ handleColumnWidthChange }
                                                    onColumnOrderChange={ handleColumnOrderChange }
                                                />
                                            ) : (
                                                null
                                            )
                                        }
                                    </ModalCtx.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    opps: state.leadopps.byId,
    loans: state.loans.byId,
    notes: state.notes.byId,
    tasks: state.tasks.byId,
    lists: state.lists.byId,
    status: state.user.meta.global.picklist.status,
    conPicklist: state.user.meta.contact.picklist,
    oppPicklist: state.user.meta.leadopp.picklist,
    globalPicklist: state.user.meta.global.picklist
} );

const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );

export default connect( mapProps, mapDispatch )( AllOpps );